import React from 'react';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import { useWishlist } from '../../context/WishlistContext.jsx';
import { useCart } from '../../context/CartContext.jsx';
import { useNavigate, Link } from 'react-router-dom';
import { FaHeart, FaTrashAlt, FaShoppingCart } from 'react-icons/fa';
import './Wishlist.scss';

const Wishlist = () => {
    const { wishlistItems, removeFromWishlist } = useWishlist();
    const { addToCart } = useCart();
    const navigate = useNavigate();

    const handleAddToCart = (item) => {
        // Defaulting to 'S' size for wishlist items since size selection isn't stored in wishlist
        addToCart(item, 'S');
        removeFromWishlist(item.id);
    };

    if (wishlistItems.length === 0) {
        return (
            <div className="empty-wishlist-page sectionPadding">
                <Container className="text-center">
                    <div className="empty-wishlist-icon mb-4">
                        <FaHeart size={80} color="#ff4d4d" />
                    </div>
                    <h2 className="title-xl mb-3">Your Wishlist is Empty</h2>
                    <p className="mb-4">You haven't saved any items yet. Start exploring our collection!</p>
                    <Link to="/" className="dBtn btnPrimary">EXPLORE PRODUCTS</Link>
                </Container>
            </div>
        );
    }

    return (
        <div className="wishlist-page sectionPadding">
            <Container>
                <div className="wishlist-header mb-5" data-aos="fade-down">
                    <h4 className="section-title-sm">Saved for Later</h4>
                    <h1 className="title-xl fw-bold">MY WISHLIST</h1>
                </div>

                <Row>
                    <Col lg={12} data-aos="fade-up">
                        <div className="wishlist-items-wrapper info-card">
                            <Table responsive className="wishlist-table">
                                <thead>
                                    <tr>
                                        <th>PRODUCT</th>
                                        <th>PRICE</th>
                                        <th>ACTION</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {wishlistItems.map((item) => (
                                        <tr key={item.id}>
                                            <td data-label="PRODUCT">
                                                <div className="product-cell d-flex align-items-center gap-3">
                                                    <div className="product-img">
                                                        <img src={item.productImage} alt={item.title} />
                                                    </div>
                                                    <div className="product-info">
                                                        <h6 className="mb-1 pointer" onClick={() => navigate(`/product/${item.id}`)} style={{ cursor: 'pointer' }}>{item.title}</h6>
                                                        <p className="mb-0 text-muted">{item.category}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td data-label="PRICE" className="align-middle">${item.price}</td>
                                            <td data-label="ACTION" className="align-middle">
                                                <Button 
                                                    className="dBtn btnPrimary btn-sm" 
                                                    onClick={() => handleAddToCart(item)}
                                                >
                                                    <FaShoppingCart className="me-2" /> ADD TO CART
                                                </Button>
                                            </td>
                                            <td className="align-middle text-end">
                                                <button className="remove-btn" onClick={() => removeFromWishlist(item.id)}>
                                                    <FaTrashAlt />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="wishlist-actions d-flex justify-content-between mt-4">
                                <Link to="/" className="dBtn btnBorder">CONTINUE SHOPPING</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Wishlist;
